export const BASE_CHAT_PATH = 'chat';